"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createNoopLogApi = createNoopLogApi;
exports.createConsoleLogApi = createConsoleLogApi;
/**
 * Create a dummy LogApi implementation that does nothing.
 *
 * If a function optionally accepts a LogApi instance, this is a very
 * convenient default value.
 */
function createNoopLogApi() {
    return {
        trace(..._args) { },
        debug(..._args) { },
        info(..._args) { },
        warn(..._args) { },
        error(..._args) { },
        fatal(..._args) { },
        child() {
            return createNoopLogApi();
        },
    };
}
/**
 * Create a dummy LogApi implementation using the console global.
 */
function createConsoleLogApi(base = {}) {
    return {
        trace(...args) {
            console.log(base, ...args);
        },
        debug(...args) {
            console.log(base, ...args);
        },
        info(...args) {
            console.log(base, ...args);
        },
        warn(...args) {
            console.error(base, ...args);
        },
        error(...args) {
            console.error(base, ...args);
        },
        fatal(...args) {
            console.error(base, ...args);
        },
        child(newBase) {
            return createConsoleLogApi({ ...base, ...(newBase || {}) });
        },
    };
}
//# sourceMappingURL=Log.js.map